export default __webpack_public_path__ + "static/googlePlay-2c733f2f98ba12c63e6d811288c3895b.webp";